function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var hasCompoundParentsExpanded = function hasCompoundParentsExpanded(parentId, compoundParent, rows) {
  // max rows.length parents
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  var _iterator = _createForOfIteratorHelper(rows),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var i = _step.value;

      if (rows[parentId].hasOwnProperty('parent')) {
        parentId = rows[parentId].parent;
      } else {
        return rows[parentId].cells[compoundParent].props.isOpen;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return false;
};

var hasParentsExpanded = function hasParentsExpanded(parentId, rows) {
  // max rows.length parents
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  var _iterator2 = _createForOfIteratorHelper(rows),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var i = _step2.value;

      if (rows[parentId].hasOwnProperty('parent')) {
        parentId = rows[parentId].parent;
      } else {
        return rows[parentId].isOpen;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return false;
};

export var isRowExpanded = function isRowExpanded(row, rows) {
  if (row.parent !== undefined) {
    if (row.hasOwnProperty('compoundParent')) {
      return hasCompoundParentsExpanded(row.parent, row.compoundParent, rows);
    }

    return hasParentsExpanded(row.parent, rows) && rows[row.parent].isOpen;
  }

  return undefined;
};
export var getErrorTextByValidator = function getErrorTextByValidator(validatorName, validators) {
  var result = validators.filter(function (validator) {
    return validator.name === validatorName;
  });
  return result[0].errorText;
};
export var cancelCellEdits = function cancelCellEdits(row) {
  row.cells.forEach(function (cell) {
    delete cell.props.errorText;
    delete cell.props.editableValue;
    cell.props.isValid = true; // for editable selects, revert the selected property to its original value

    if (cell.props.selected) {
      cell.props.selected = cell.props.value;
    }
  });
  row.isEditable = !row.isEditable;
  row.isValid = true;
  return row;
};
export var validateCellEdits = function validateCellEdits(row, type, validationErrors) {
  var missingPropErrorTxt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'Validation requires unique name property for row cells';
  row.isValid = Object.keys(validationErrors).length ? false : true;
  row.cells.forEach(function (cell) {
    delete cell.props.errorText;
    var hasValue = cell.props.value !== undefined && cell.props.value !== null;
    var hasEditableValue = cell.props.editableValue !== undefined && cell.props.editableValue !== null;

    if (cell.props && hasValue && hasEditableValue) {
      if (type === 'save') {
        var errorMsg = Object.keys(validationErrors).filter(function (validatorName) {
          return validationErrors[validatorName].includes(cell.props.name);
        }).map(function (validatorName) {
          return getErrorTextByValidator(validatorName, row.rowEditValidationRules);
        });

        if (errorMsg.length) {
          cell.props.errorText = cell.props.name ? errorMsg.join(', ') : missingPropErrorTxt;

          if (cell.props.name === undefined) {
            // eslint-disable-next-line no-console
            console.warn('Row edit validation reporting requires cell definitions to have a unique name property.');
          }
        } else {
          delete cell.props.errorText;
          cell.props.isValid = true;
        }
      }
    }
  });
  return row;
};
export var applyCellEdits = function applyCellEdits(row, type) {
  row.cells.forEach(function (cell) {
    delete cell.props.errorText;
    var hasValue = cell.props.value !== undefined && cell.props.value !== null;
    var hasEditableValue = cell.props.editableValue !== undefined && cell.props.editableValue !== null; // sync for validation

    if (hasValue && !hasEditableValue) {
      cell.props.editableValue = cell.props.value;
    }

    if (cell.props && hasValue && hasEditableValue) {
      if (type === 'save') {
        cell.props.value = cell.props.editableValue;
        cell.props.isValid = true;
        delete cell.props.errorText;
      }

      delete cell.props.editableValue;
    }
  });
  row.isEditable = !row.isEditable;
  row.isValid = true;
  return row;
};

var camelize = function camelize(s) {
  return s.toUpperCase().replace('-', '').replace('_', '');
};

export var toCamel = function toCamel(s) {
  return s.replace(/([-_][a-z])/gi, camelize);
};
/**
 * @param {string} input - String to capitalize
 */

export function capitalize(input) {
  return input[0].toUpperCase() + input.substring(1);
}